import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

// Validation schema
const validationSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  description: Yup.string().required('Description is required'),
  sequence: Yup.number()
    .required('Order is required')
    .positive('Order must be positive')
    .integer('Order must be an integer'),
});

// Custom input component (replaces renderInput)
const CustomInput = ({ field, form, ...props }) => {
  const hasError = form.touched[field.name] && form.errors[field.name];

  return (
    <div className={props.parentClass || 'form-group'}>
      <input
        {...field}
        {...props}
        className={`${props.className || 'form-control'} ${hasError ? 'error' : ''}`}
        disabled={props.disabled}
      />
      {hasError && (
        <div className="error-message" style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
          {form.errors[field.name]}
        </div>
      )}
    </div>
  );
};

class CreateDifficulties extends Component {
  getInitialValues = () => {
    if (this.props.mode === 'EDIT' && this.props.initialValues) {
      return {
        name: this.props.initialValues.name || '',
        description: this.props.initialValues.description || '',
        sequence: this.props.initialValues.sequence || 0,
      };
    }

    return {
      name: '',
      description: '',
      sequence: 0,
    };
  };

  handleSubmit = (values, { setSubmitting }) => {
    if (this.props.mode === 'EDIT') {
      this.props.onEdit(values);
    } else {
      this.props.onCreate(values);
    }
    setSubmitting(false);
  };

  render() {
    const { mode, isCreating, accessMode } = this.props;
    const isViewMode = accessMode === 'view';
    const isEditMode = accessMode === 'edit';

    return (
      <div className="well create-piece">
        <Formik
          initialValues={this.getInitialValues()}
          validationSchema={validationSchema}
          onSubmit={this.handleSubmit}
          enableReinitialize={true} // Important for EDIT mode
        >
          {({ isSubmitting, isValid, dirty }) => (
            <Form>
              <div className="row">
                <div className="col-md-3">
                  <label>Name</label>
                </div>
                <div className="col-md-9">
                  <Field
                    name="name"
                    type="text"
                    placeholder="Name"
                    component={CustomInput}
                    className={`form-control ${isViewMode ? 'disabled' : ''}`}
                    parentClass="form-group"
                    disabled={isViewMode}
                  />
                </div>

                <div className="col-md-3">
                  <label>Description</label>
                </div>
                <div className="col-md-9">
                  <Field
                    name="description"
                    type="text"
                    placeholder="Description"
                    component={CustomInput}
                    className={`form-control ${isViewMode ? 'disabled' : ''}`}
                    parentClass="form-group"
                    disabled={isViewMode}
                  />
                </div>

                <div className="col-md-3">
                  <label>Order</label>
                </div>
                <div className="col-md-9">
                  <Field
                    name="sequence"
                    type="number"
                    placeholder="Sequence"
                    component={CustomInput}
                    className={`form-control ${isViewMode ? 'disabled' : ''}`}
                    parentClass="form-group"
                    disabled={isViewMode}
                  />
                </div>
              </div>

              {isEditMode && (
                <div className="create-piece__btn-container">
                  <button
                    className="cus-btn-primary btn-block btn-lg"
                    type="submit"
                    disabled={isCreating || isSubmitting || !isValid}
                  >
                    {isCreating || isSubmitting ? (
                      <span className="spinner" />
                    ) : (
                      <span>{mode === 'EDIT' ? 'Edit' : 'Create'}</span>
                    )}
                  </button>
                </div>
              )}
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

export default CreateDifficulties;
